module.exports = __webpack_public_path__ + "img/002_conforza.c39928ba.gif";